/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/bus'
export default icon
